import { render, staticRenderFns } from "./EmployeeButtonPrint.vue?vue&type=template&id=0bb56dd3"
import script from "./EmployeeButtonPrint.vue?vue&type=script&lang=js"
export * from "./EmployeeButtonPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports